import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import React from "react";
import { tokens } from '../../../assets/tokens'

// Contenido del ActionDialog: campos en columna con su label encima
export const ModalStyled = styled.div`
  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${tokens.color.text.label};
  }
`

export const ButtonExport = styled(props => <Button {...props}/>)`
    /* Sin margen propio: el hueco lo da el gap de la cabecera y el último botón llega al borde */
    margin-right: 0 !important;
`
